import React from "react";
import { IconButton } from "@material-ui/core";
import { Table } from "..";
import { dateFormatter } from "../../utils/common";
import {
  resolveSubActivityDisplay,
  sortTimesheetItemsByDateAsc,
} from "../../utils/timesheetHelpers";
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import CloseIcon from "@material-ui/icons/Close";
import "./timesheet.css";

export default function TimesheetView({ data, id, onClose }) {
  return (
    <div className="timesheet-view-wrapper" id={id}>
      <div className="timesheet-view-header">
        <h2 className="timesheet-view-title">Timesheet View</h2>
        {onClose && (
          <IconButton
            className="timesheet-view-close-btn"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        )}
      </div>

      {/* Summary Section - Clean White Card */}
      <div className="timesheet-summary-card">
        <div className="summary-item">
          <span className="summary-label">Start Date:</span>{" "}
          <span className="summary-value">{dateFormatter(data.start_date)}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">End Date:</span>{" "}
          <span className="summary-value">{dateFormatter(data.end_date)}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Employee Name:</span>{" "}
          <span className="summary-value">{data.employee_name || "---"}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Total Hours:</span>{" "}
          <span className="summary-value">{data.total_hours || "---"}</span>
        </div>
      </div>

      {/* Rejected Comments Section (if exists) */}
      {data.rejected_comments && (
        <div className="rejected-comments-section">
          <h3 className="rejected-comments-title">Rejected Comments</h3>
          <div className="rejected-comments-content">
            {data.rejected_comments}
          </div>
        </div>
      )}

      {/* Table Section */}
      <div className="timesheet-table-container">
        <Table
          variant="small"
          title=""
          aligncss="timesheet-view-table"
          header={[
            { id: "1", label: "Date" },
            { id: "2", label: "Billed Type" },
            { id: "3", label: "Client" },
            { id: "4", label: "Business Name" },
            { id: "5", label: "Activity" },
            { id: "6", label: "Sub Activity" },
            { id: "7", label: "Description" },
            {
              id: "8",
              label: (
                <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                  Hours
                  <FilterListOutlinedIcon style={{ fontSize: "18px", color: "#6b7280", cursor: "pointer" }} />
                </span>
              )
            },
          ]}
          data={
            data?.itemDetails
              ? sortTimesheetItemsByDateAsc(data.itemDetails).map(
                  ({
                    date,
                    billed_type,
                    client_name,
                    client_email,
                    business_name,
                    activity,
                    sub_activity,
                    hours,
                    description,
                    activity_id,
                    custom_sub_activity,
                  }) => {
                    const isOthers =
                      (activity_id === null || activity_id === 0) &&
                      custom_sub_activity;

                    return {
                      date: dateFormatter(date),
                      billed_type: billed_type || "---",
                      client_name: client_name || client_email || "---",
                      business_name: business_name || "---",
                      activity: isOthers ? "Others" : (activity || "---"),
                      sub_activity: resolveSubActivityDisplay({
                        sub_activity,
                        custom_sub_activity,
                      }),
                      description: description || "---",
                      hours: hours || "---",
                    };
                  }
                )
              : []
          }
        />
      </div>
    </div>
  );
}